<p-card header="Deine Interessen und sonstigen Aktivitäten">
  <div class="flex flex-col gap-2">
    <p>Hier können z.B. auch Stipendien und Auszeichnungen eingetragen werden, aber auch Freizeitbeschäftigungen.</p>
    <p-fluid>
      <textarea pTextarea [formControl]="sonstiges" rows="8"></textarea>
      <div class="flex justify-between items-start">
        <div>
          @if (sonstiges.hasError('minlength')) {
            <span class="form-hint-text-error"> Mindestens {{ sonstiges.errors?.['minlength']?.requiredLength }} Zeichen eingeben. </span>
          }
        </div>
        <small [ngClass]="sonstiges.errors && this.sonstiges.errors['maxlength'] ? 'form-hint-text-error' : 'form-hint-text'">
          {{ sonstiges.value?.length ?? 0 }} /{{ sonstigesMaxLength }}
        </small>
      </div>
    </p-fluid>
  </div>
</p-card>
